import { render } from "./editScoringTableCategoriesModal.vue?vue&type=template&id=5c693915&scoped=true&ts=true"
import script from "./editScoringTableCategoriesModal.vue?vue&type=script&lang=ts"
export * from "./editScoringTableCategoriesModal.vue?vue&type=script&lang=ts"

import "./editScoringTableCategoriesModal.vue?vue&type=style&index=0&id=5c693915&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c693915"]])

export default __exports__